import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createRootReducer from './reducers/index';
import createSagaMiddleware from 'redux-saga';
import { fromJS, Map } from 'immutable';
import wpSaga from './middlewares/wp-saga'
import printSaga from './middlewares/print-saga';
import { TRANSLATION } from './constants/state'
import programSaga from './middlewares/programSaga';
import newsletterSaga from './middlewares/newsletterSaga';
import signageSaga from './middlewares/signageSaga';
import multisiteSelectorSaga from './middlewares/multisiteSelectorSaga';
import loadAllSaga from './middlewares/loadAllSaga';
import routesDataSaga from './middlewares/routesDataSaga';
import cliDataSaga from './middlewares/cliDataSaga';
import { requestInitLoad } from './actions';
import authSaga from './middlewares/authSaga';
import { createHashHistory } from 'history'
import { routerMiddleware } from 'connected-react-router/immutable'
import eventSaga from './middlewares/eventSaga';
import clientUserSaga from './middlewares/clientUser';
import pushSaga from './middlewares/push-saga'
import dashboardSaga from './middlewares/dashboardSaga';
import tmdbSaga from './middlewares/tmdbSaga'
import metaMappingSaga from './middlewares/metaMappingSaga'
import previewMoviesSaga from './middlewares/previewMoviesSaga'
import socialMediaSaga from './middlewares/socialMediaSaga'


//// Local Storrage
// const loadState = () => {
//   try {
//     const serializedState = localStorage.getItem('state')

//     if (serializedState === null) {
//       return {}
//     } else {
//       const s = JSON.parse(serializedState)

//       return {
//         // newsletterLocalData: {
//         //   newsletters: s.newsletterLocalData.newsletters,
//         //   texts: s.newsletterLocalData.texts,
//         //   images: s.newsletterLocalData.images
//         // },
//         // signageData: s.signageData
//       }
//     }
//   } catch (err) {
//     return {};
//   }
// }

// const saveState = (state) => {
//   try {
//     const serializedState = JSON.stringify(state);
//     localStorage.setItem('state', serializedState);
//   } catch {
//     // ignore write errors
//   }
// }


const PRELOADED_STATE = new Map({
  [TRANSLATION]: fromJS(pmkinoClientVars.translation)
})

// const persistedState = loadState();
const sagaMiddleware = createSagaMiddleware();

export const history = createHashHistory()

export const store = createStore(
    createRootReducer(history),
    PRELOADED_STATE,
    // PRELOADED_STATE.merge(fromJS(persistedState)),
    composeWithDevTools(
        applyMiddleware(
            routerMiddleware(history),
            sagaMiddleware
        )   
    ),
);

sagaMiddleware.run(authSaga)
sagaMiddleware.run(loadAllSaga)
sagaMiddleware.run(programSaga)
sagaMiddleware.run(wpSaga);
sagaMiddleware.run(newsletterSaga)
sagaMiddleware.run(signageSaga)
sagaMiddleware.run(printSaga)
sagaMiddleware.run(multisiteSelectorSaga)
sagaMiddleware.run(routesDataSaga)
sagaMiddleware.run(cliDataSaga)
sagaMiddleware.run(eventSaga)
sagaMiddleware.run(clientUserSaga)
sagaMiddleware.run(pushSaga)
sagaMiddleware.run(dashboardSaga)
sagaMiddleware.run(tmdbSaga)
sagaMiddleware.run(metaMappingSaga)
sagaMiddleware.run(previewMoviesSaga)
sagaMiddleware.run(socialMediaSaga)

store.dispatch(requestInitLoad())

// store.subscribe(_.throttle(() => {
//   const s = {
//     // newsletterLocalData: {
//     //   newsletters: store.getState().getIn(['newsletterLocalData', 'newsletters']).toJS(),
//     //   texts: store.getState().getIn(['newsletterLocalData', 'texts']).toJS(),
//     //   images: store.getState().getIn(['newsletterLocalData', 'images']).toJS()
//     // },
//     // signageData: store.getState().getIn(['signageData']).toJS()
//   }
//   // saveState(store.getState().getIn(['newsletterLocalData', 'newsletters']).toJS());
//   saveState(s);
// }), 1000);